import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import useDebounce from "../../hooks/useDebounce";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { Avatar, IconButton } from "@mui/material";
import Switch from "../../components/Switch/Switch";
import NotFound from "../../components/not-found/NotFound";
import Pagination from "react-js-pagination";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { category, community, music, vastuCompass } from "../../routes/route";
import common from "../../routes/common";
import { toastMessage } from "../../utils/toastMessage";
import findSerialNumber from "../../utils/findSerialNumber";
import { charLimit } from "../../utils/charLimit";
import EditIcon from "@mui/icons-material/Edit";
// import AddMusic from './AddMusicCategory'
import showFullSizeImage from "../../utils/showFullSizeImage";
// import MusicCategoryStatus from './MusicCategoryStatus'
// import EditMusicCategory from './EditMusicCategory'
import scrollToUp from "../../utils/scrollToUp";
import { getLocalStorage, setLocalStorage } from "../../config/config";
import ImagePreviewModel from "../../components/imagePreview/ImagePreviewModel";
import { fetchVastuCategoryApi } from "../../services/vastuCompassCategory";
import { fetchCommunityApi } from "../../services/communityManagement";
// import VastuCompassCategoryStatus from './VastuCompassCategoryStatus'
// import AddVastuCompass from './AddVastuCompass'
// import EditVastuCompass from './EditVastuCompass'
const { NOT_FOUND } = common;
const { COMMUNITY_DETAIL } = community;

const CommunityManagement = () => {
  // handle all state
  const [searchParam, setSearchParam] = useSearchParams();
  let activePage = +searchParam.get("page") || 1;
  // const [search, setSearch] = useState(searchParam.get('query') || '')
  const [search, setSearch] = useState(
    getLocalStorage("musicCategory", "search") || ""
  );
  const debounceValue = useDebounce(search || "", 300);

  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [communityList, setCommuntiyList] = useState([]);
  const [total, setTotal] = useState(0);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [statusModal, setStatusModal] = useState(false);
  const [statusValue, setStatusValue] = useState("");
  const [statusId, setStatusId] = useState("");
  const [selectedVastuDetail, setSelectedVastuDetail] = useState(null);
  const [showImagePreviewModel, setShowImagePreviewModel] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [imageTitle, setImageTitle] = useState("");

  // Function to set localStorage values whenever the state variables change
  useEffect(() => {
    setLocalStorage("musicCategory", "search", search);
  }, [search]);
  //*********Handel status********* */
  const statusUpdateHandler = (id, status) => {
    setStatusModal(true);
    setStatusId(id);
    setStatusValue(status);
  };

  // update music category handler
  const updateCommunityHandler = (data) => {
    setSelectedVastuDetail(data || null);
    setEditModal(true);
  };

  //*********Handel Block********* */
  // const blockHandler = (id, status) => {
  //     setBlockModal(true);
  //     setBlockId(id);
  //     // setStatusValue(status);
  // };
  //*********Handle update********* */
  // const updateHandler = (id, enName, arName, imageUrl, categoryId) => {
  //   setUpdateModal(true)
  //   setUpdateSubCategoryData({
  //     id,
  //     enName,
  //     arName,
  //     imageUrl,
  //     categoryId,
  //   })
  // }
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParam.set("page", event);
    setSearchParam(searchParam);
  };

  const showImagePreviewHandler = (community) => {
    setShowImagePreviewModel(true);
    setImagePreview(community.communityImage);
    setImageTitle(music.title);
  };

  // close model

  const closeModel = () => {
    setSelectedVastuDetail(null);
    setStatusValue("");
    setStatusId("");
    setAddModal(false);
    setStatusModal(false);
    setEditModal(false);
    setImagePreview("");
    setImageTitle("");
    setShowImagePreviewModel(false);
  };

  // //------------------listing-music-Api----------------------------------
  const fetchCommunityHandler = async () => {
    try {
      setCommuntiyList([]);
      showLoader();
      const sendData = {
        page: activePage,
        limit: 10,
      };
      if (debounceValue) {
        sendData.page = 1;
        sendData.search = debounceValue;
        searchParam.delete("page");
        setSearchParam(searchParam);
      }
      const { data } = await fetchCommunityApi(sendData);
      if (data.code === 200) {
        setCommuntiyList(data?.result?.list || []);
        setTotal(data?.result?.total || 0);
        scrollToUp();
      } else {
        setCommuntiyList([]);
        setTotal(0);
        toastMessage(data.message, "error", "musicList");
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      hideLoader();
    }
  };

  // console.log(communityList, "communityList");

  // useEffect(() => {
  //   if (debounceValue) {
  //     searchParam.set('query', debounceValue)
  //   } else {
  //     searchParam.delete('query')
  //   }
  //   if (activePage === 1) {
  //     searchParam.delete('page')
  //   }
  //   setSearchParam(searchParam)
  //   fetchCategoryHandler(activePage, debounceValue)
  // }, [searchParam, debounceValue])
  useEffect(() => {
    if (activePage === 1) {
      searchParam.delete("page");
    }
    setSearchParam(searchParam);
    fetchCommunityHandler();
  }, [searchParam, debounceValue]);
  return (
    <>
      {loader}
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="TitleBox">
            <h4 className="Title">Community Management</h4>
            {/* <div className="block_user_button">
              <button onClick={() => setAddModal(true)}>
                Add Category
              </button>
            </div> */}
          </div>
          <div className="FilterBox FilterArea ">
            <div className="form-group search_lg_size userSearch">
              <input
                type="search"
                className="form-control"
                placeholder="Search"
                value={search || ""}
                style={{ "--color": "#FF8989" }}
                onChange={(e) => setSearch(e.target.value)}
              />
              <span className="user_search_icon">{common.SEARCH_ICON}</span>
            </div>
          </div>
          <div className="content-table">
            <table>
              <thead>
                <tr>
                  <th>S. No.</th>
                  <th>Community Name</th>
                  <th>Description</th>
                  <th>Community Image</th>
                  <th className="text-center"> Action </th>
                </tr>
              </thead>

              <tbody>
                {communityList.length > 0 ? (
                  communityList.map((community, index) => {
                    return (
                      <React.Fragment key={community._id}>
                        <tr>
                          <td>{findSerialNumber(index, activePage, 10)}</td>
                          <td>{charLimit(community.title, 30) || "---"}</td>
                          <td>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: charLimit(community.description, 30),
                              }}
                            />
                          </td>
                          <td>
                            <Avatar
                              id={community._id}
                              alt={community.title}
                              src={community.communityImage}
                              sx={{
                                width: 50,
                                height: 50,
                                cursor: "pointer",
                                borderRadius: 2,
                              }}
                              onClick={() => showImagePreviewHandler(community)}
                            />
                          </td>

                          <td>
                            <div className="action_button">
                              <Link to={`${COMMUNITY_DETAIL}/${community._id}`}>
                                <IconButton
                                  aria-label="update"
                                  className="px-2 py-0"
                                >
                                  <VisibilityIcon className="eye_icon" />
                                </IconButton>
                              </Link>
                              {/* <IconButton
                                aria-label="update"
                                className="px-2 py-0"
                                onClick={() =>
                                  updateCommunityHandler(community)
                                }
                              >
                                <EditIcon className="edit_icon" />
                              </IconButton> */}
                              {/* <Switch
                                checked={community.status}
                                onChange={() =>
                                  statusUpdateHandler(community._id, community.status)
                                }
                              /> */}
                            </div>
                          </td>
                        </tr>
                      </React.Fragment>
                    );
                  })
                ) : (
                  <NotFound
                    cols={7}
                    msg="Community not found!"
                    icon={NOT_FOUND}
                    loader={loader}
                  />
                )}
              </tbody>
            </table>
          </div>
          {total >= 10 ? (
            <div className="pagination-wrapper">
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={10}
                  onChange={handlePageChange}
                  hideDisabled={true}
                />
              </div>
            </div>
          ) : null}

          {/* <FloatingButton
            onClick={() => setAddModalShow(true)}
            icon={<AddIcon />}
          /> */}
        </div>
        {/* {addModal && (
          <AddVastuCompass
            show={addModal}
            close={closeModel}
            listing={fetchCommunityHandler}
          />
        )}
        {statusModal && (
          <VastuCompassCategoryStatus
            show={statusModal}
            close={closeModel}
            setListing={setCommuntiyList}
            status={statusValue}
            id={statusId}
          />
        )}
        {editModal && (
          <EditVastuCompass
            show={editModal}
            close={closeModel}
            selectedVastuDetail={selectedVastuDetail}
            setSelectedVastuDetail={setSelectedVastuDetail}
            vastuListing={fetchCommunityHandler}
          />
        )} */}
        {showImagePreviewModel && (
          <ImagePreviewModel
            show={showImagePreviewModel}
            close={closeModel}
            imageUrl={imagePreview}
            title={imageTitle}
          />
        )}
      </div>
    </>
  );
};

export default CommunityManagement;
